<template>
  <div class="card">
    <div style="margin-bottom:10px;">Product No.: {{ $route.params.id }}</div>
    <el-row>
      <el-col :span="24">
        <table class="fixed-table">
          <tr>
            <th style="width:76px;">Issue Date</th>
            <th style="width:94px;">Delivery Date</th>
            <th style="width:84px;">INV No.</th>
            <th>Company</th>
            <th style="width:52px;">HK Stk</th>
            <th style="width:52px;">SZ Stk</th>
            <th style="width:46px;">BB</th>
            <th style="width:62px;">Price</th>
            <th style="width:50px;background:#800080;color:#fff;">Type</th>
            <th style="width:50px;background:#800080;color:#fff;">Qty</th>
            <th style="width:62px;background:#800080;color:#fff;">Cost</th>
            <th style="width:80px;background:#800080;color:#fff;">Vendor</th>
            <th style="width:78px;">Sales</th>
          </tr>
          <template v-for="(item, index) in list">
            <tr :key="index">
              <td>{{item.doc_date}}</td>
              <td>{{item.delivery_date_e}}</td>
              <td v-if="(user.role_id < 3 || item.create_oper_id == user.id)"><a @click="$open(`/invoice-order-view/${item.doc_id}`, 840)">{{item.doc_id_display}}</a></td>
              <td v-else>{{item.doc_id_display}}</td>
              <td v-if="(user.role_id < 3 || item.create_oper_id == user.id)" :title="item.company_fullname">{{item.company_fullname}}</td>
              <td v-else></td>
              <td style="text-align:right;">{{item.qty_hk|1000}}</td>
              <td style="text-align:right;">{{item.qty_sz|1000}}</td>
              <td style="text-align:right;">{{item.qty_bb|1000}}</td>
              <td><span style="color:#6f76b1">{{item.currency}}</span>{{item.price|1000}}</td>
              <td colspan="4">
                <table class="fixed-table inner-table">
                  <tr v-if="item.qty_hk>0">
                    <td style="width:50px;">HK stk</td>
                    <td style="width:50px;text-align:right;">{{item.qty_hk|1000}}</td>
                    <td style="width:62px;"><span style="color:#6f76b1">{{item.currency}}</span>{{item.hk_cost}}</td>
                    <td :title="item.hk_vendor" v-if="(user.role_id < 3 || item.create_oper_id == user.id)">{{item.hk_vendor}}</td>
                    <td v-else>&nbsp;</td>
                  </tr>
                  <tr v-if="item.qty_sz>0">
                    <td style="width:50px;">SZ stk</td>
                    <td style="width:50px;text-align:right;">{{item.qty_sz|1000}}</td>
                    <td style="width:62px;"><span style="color:#6f76b1">{{item.currency}}</span>{{item.sz_cost}}</td>
                    <td :title="item.sz_vendor" v-if="(user.role_id < 3 || item.create_oper_id == user.id)">{{item.sz_vendor}}</td>
                    <td v-else>&nbsp;</td>
                  </tr>
                  <tr v-if="item.qty_bb>0">
                    <td style="width:50px;">BB</td>
                    <td style="width:50px;text-align:right;">{{item.qty_bb|1000}}</td>
                    <td style="width:62px;"><span style="color:#6f76b1">{{item.currency}}</span>{{item.bb_cost}}</td>
                    <td :title="item.bb_vendor" v-if="(user.role_id < 3 || item.create_oper_id == user.id)">{{item.bb_vendor}}</td>
                    <td v-else>&nbsp;</td>
                  </tr>
                </table>
              </td>
              <td>{{item.sales_fullname}}</td>
            </tr>
          </template>
        </table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    fetchList () {
      this.$http('/dbapi/invoice_list?product_id=' + this.$route.params.id).then(data => {
        this.list = data.list
      })
    }
  }
}
</script>